// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G2MFx","toggleWrap":"styles_toggleWrap__1b3wN","content":"styles_content__1t8II","selectAreaCode":"styles_selectAreaCode__hwLlX"};